<input #fileInput hidden="true" type="file" name="file" onclick="this.value = null" (change)="fileInputChanged($event)" [accept]="acceptedFileTypesString" />
@if (chosenFile === null) {
  <button mat-flat-button color="primary" (click)="fileInput.click()" translate="COMMON.CHOOSE_A_FILE" type="button"></button>
} @else {
  <div class="file-name-container">
    @if (!isUploading && !isScanning) {
      <button mat-icon-button color="warn" type="button" (click)="removeFile()" [matTooltip]="'COMMON.REMOVE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    }
    {{ chosenFile.name }} ({{ chosenFile.size | filesize }})
  </div>
  @if (isScanning) {
    <div class="upload-progress">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <span class="upload-progress-text" translate="UPLOADS.SCANNING"></span>
    </div>
  } @else if (isUploading) {
    <div class="upload-progress">
      <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
      <span class="upload-progress-text">
        {{ uploadProgress }}%
        @if (remainingTimeSeconds !== null) {
          - {{ 'COMMON.TIME_REMAINING' | translate: { time: (remainingTimeSeconds | duration: true) } }}
        }
      </span>
    </div>
  }
}
